

















import {
  Component,
  Emit,
  Inject,
  Model,
  Prop,
  Provide,
  Vue,
  Watch
} from "vue-property-decorator";
import ImgFetched from "@/components/ImgFetched/ImgFetched.vue";
@Component({
  components: {
    ImgFetched
  }
})
export default class UserOneItem extends Vue {
  @Prop()
  private userList: any;
  private clickMore() {
    this.$emit("click");
  }
}
